import { ActionBus } from '@eroman/common/src/_base/actionBus/ActionBus';
import { GetPublicBookings } from '@eroman/common/src/actions/amenities/booking/getBookings/GetPublicBookings';
import { BookingsVM } from '@eroman/common/src/views/app/Bookings/BookingsVM';
import { CancelBooking } from '@eroman/common/src/actions/amenities/booking/cancelBooking/CancelBooking';
import { CannotCancelError } from '@eroman/common/src/models/bookings/CannotCancelError';
import { SessionStorage } from '@eroman/common/src/models/session/SessionStorage';
import { WebNavigator } from '../../lib/navigation/WebNavigator';

export interface BookingsView {
    modelChanged(model);
}

export class BookingsPresenter {
    private model = new BookingsVM();

    constructor(private view: BookingsView, private actionBus: ActionBus, private navigator: WebNavigator) {}

    async start() {
        const amenityId = parseInt(this.navigator.currentRoute?.params?.amenityId, 10);
        console.log(parseInt(this.navigator.currentRoute?.params?.amenityId, 10))
        this.set({ amenityId });
        await this.loadBookings(amenityId);
    }

    private async loadBookings(amenityId: number) {
        const bookings = await this.actionBus.query(new GetPublicBookings(amenityId));
        this.set({ bookings });
    }

    set<K extends keyof BookingsVM>(changes: Pick<BookingsVM, K>) {
        this.model = Object.assign(this.model, changes);
        this.view.modelChanged(this.model);
    }
}
